import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCurlyBracket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4.25 5.689A2.94 2.94 0 0 1 7.189 2.75H8a.75.75 0 0 1 0 1.5h-.811c-.795 0-1.439.644-1.439 1.439v2.16c0 .92-.523 1.748-1.325 2.151a2.41 2.41 0 0 1 1.325 2.15v2.161c0 .795.644 1.439 1.439 1.439H8a.75.75 0 0 1 0 1.5h-.811a2.94 2.94 0 0 1-2.939-2.939v-2.16a.91.91 0 0 0-.639-.867l-1.193-.37c-.9-.278-.9-1.55 0-1.828l1.193-.37a.91.91 0 0 0 .639-.866zm7-2.189a.75.75 0 0 1 .75-.75h.811a2.94 2.94 0 0 1 2.939 2.939v2.16c0 .398.259.75.639.867l1.194.37c.898.278.898 1.55 0 1.828l-1.194.37a.91.91 0 0 0-.639.866v2.161a2.94 2.94 0 0 1-2.939 2.939H12a.75.75 0 0 1 0-1.5h.811c.795 0 1.439-.644 1.439-1.439v-2.16c0-.92.523-1.748 1.325-2.151a2.41 2.41 0 0 1-1.325-2.15V5.689c0-.795-.644-1.439-1.439-1.439H12a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCurlyBracket;
